/* tslint:disable */
/* eslint-disable */
/**
 * mama health backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LandbotSettings
 */
export interface LandbotSettings {
    /**
     * 
     * @type {string}
     * @memberof LandbotSettings
     */
    landbotUrlTx: string;
    /**
     * 
     * @type {string}
     * @memberof LandbotSettings
     */
    landbotSettingsJson?: string;
}

/**
 * Check if a given object implements the LandbotSettings interface.
 */
export function instanceOfLandbotSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "landbotUrlTx" in value;

    return isInstance;
}

export function LandbotSettingsFromJSON(json: any): LandbotSettings {
    return LandbotSettingsFromJSONTyped(json, false);
}

export function LandbotSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LandbotSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'landbotUrlTx': json['landbotUrlTx'],
        'landbotSettingsJson': !exists(json, 'landbotSettingsJson') ? undefined : json['landbotSettingsJson'],
    };
}

export function LandbotSettingsToJSON(value?: LandbotSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'landbotUrlTx': value.landbotUrlTx,
        'landbotSettingsJson': value.landbotSettingsJson,
    };
}

